import type { WorkoutSession } from '../../types';
import { CARDS, TEXT } from '../../styles/classNames';
import { formatSessionStatus } from '../../lib/useSessionReview';

interface TrainerSessionsListProps {
  sessions: WorkoutSession[];
  clientNameMap?: Map<string, string>;
  hideClientName?: boolean;
  onSessionClick?: (sessionId: string) => void;
}

export function TrainerSessionsList({
  sessions,
  clientNameMap,
  hideClientName = false,
  onSessionClick,
}: TrainerSessionsListProps) {
  if (sessions.length === 0) {
    return <p className={TEXT.small}>No sessions yet.</p>;
  }

  return (
    <div className="space-y-2 max-h-72 overflow-auto pr-1">
      {sessions.map((session) => {
        const clientName = clientNameMap?.get(session.clientId) || 'Unknown client';
        const formattedDate = (session.startedAt as any)?.toDate?.()?.toLocaleString?.() || 'Not started';

        return (
          <button
            key={session.id}
            onClick={() => onSessionClick?.(session.id)}
            className={`${CARDS.nested} block w-full text-left hover:border-primary-500/50 transition-colors cursor-pointer`}
          >
            <p className={TEXT.h3}>{session.workoutSnapshot?.name || 'Session'}</p>
            <p className={TEXT.muted}>
              {formatSessionStatus(session.status)} · {formattedDate}
            </p>
            {!hideClientName && (
              <p className={TEXT.small}>Client: {clientName}</p>
            )}
          </button>
        );
      })}
    </div>
  );
}
